export enum PDFToMarkdownConversionMethod {
  LlamaParse = "LLAMA_PARSE",
  PyMuPdf4Llm = "PYMUPDF4LLM",
  MistralOcr = "MISTRAL_OCR",
  Gemini = "GEMINI",
  Markitdown = "MARKITDOWN",
}
